import { colorNeutralForeground1, colorNeutralStroke2, fontFamilyBase, fontSizeBase300, lineHeightBase300, spacingVerticalM, spacingHorizontalS, strokeWidthThin, fontWeightSemibold } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
import { forcedColorsStylesheetBehavior } from "../../util/index.js";
export const styles = css `
  fabric-simple-table {
    display: block;
    font-family: ${fontFamilyBase};
  }

  .microsoft-fabric-ux-fabric-simple-table {
    border-collapse: collapse;
    width: 100%;
    font-size: ${fontSizeBase300};
    line-height: ${lineHeightBase300};
  }

  .microsoft-fabric-ux-fabric-simple-table tr {
    box-sizing: border-box;
    color: ${colorNeutralForeground1};
  }

  .microsoft-fabric-ux-fabric-simple-table tbody tr {
    border-block-end: ${strokeWidthThin} solid ${colorNeutralStroke2};
  }

  .microsoft-fabric-ux-fabric-simple-table th {
    color: ${colorNeutralForeground1};
    text-align: start;
    font-weight: ${fontWeightSemibold};
    vertical-align: middle;
    padding-block: ${spacingVerticalM};
    padding-inline: ${spacingHorizontalS};
  }

  .microsoft-fabric-ux-fabric-simple-table td {
    padding-block: ${spacingVerticalM};
    padding-inline: ${spacingHorizontalS};
    vertical-align: middle;
    color: ${colorNeutralForeground1};
  }
`.withBehaviors(forcedColorsStylesheetBehavior(css `
    .microsoft-fabric-ux-fabric-simple-table {
      color: CanvasText;
      background-color: Canvas;
    }

    .microsoft-fabric-ux-fabric-simple-table tr {
      border-color: CanvasText;
    }

    .microsoft-fabric-ux-fabric-simple-table th {
      color: CanvasText;
      border-color: CanvasText;
    }

    .microsoft-fabric-ux-fabric-simple-table td {
      color: CanvasText;
    }
  `));
//# sourceMappingURL=simple-table.styles.js.map